// This file is documented in isomorphic
const { pickComponentHelper } = require("../isomorphic/pick-component-helper");

exports.pickComponentHelper = pickComponentHelper;
